import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { createAsyncActionTypes, createReducer } from '@mews/framework';
import { getStringProp, keyById } from '@mews/fp';
import { createFetchAction } from '@mews-commander/utils';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { META_STATE_SUCCEEDED, META_STATE_STARTED, META_STATE_FAILED } from '../constants';

export const NAME = 'chains';

export const initialState = {
    data: {},
    ...META_STATE_SUCCEEDED,
};
export const USER_CHAINS_LOADED = prefix('USER_CHAINS_LOADED');
export const CHAINS_FETCH = prefix('CHAINS_FETCH');
export const [CHAINS_FETCH_STARTED, CHAINS_FETCH_SUCCEEDED, CHAINS_FETCH_FAILED] = createAsyncActionTypes(CHAINS_FETCH);

const fetchChains =
    ({ chainIds = [] }) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { chainComponent } = container();
        const promise = chainComponent.getAll({ chainIds }).then(({ chains }: $TSFixMe) => chains);

        dispatch(createFetchAction(CHAINS_FETCH, promise));
    };

export const fetchAllChains = () => fetchChains({});

export const chainsReducer = createReducer(initialState, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [USER_CHAINS_LOADED]: (state, chains) => ({
        ...state,

        data: {
            ...state.data,
            ...keyById(chains),
        },
    }),
    [CHAINS_FETCH_STARTED]: (state: $TSFixMe) => ({
        ...state,
        ...META_STATE_STARTED,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [CHAINS_FETCH_SUCCEEDED]: (state, chains) => ({
        data: {
            ...state.data,
            ...keyById(chains),
        },

        ...META_STATE_SUCCEEDED,
    }),
    [CHAINS_FETCH_FAILED]: (state: $TSFixMe) => ({
        ...state,
        ...META_STATE_FAILED,
    }),
});

const getChainsModule = createSelector(moduleSelector, (module) => module[NAME] || {});

export const getChains = flow(getChainsModule, (chains) => chains.data);

export const getChain = createSelector(getChains, getStringProp('chainId'), (chains, chainId) => chains[chainId] || {});
